import { useEffect, useState } from "react"
import { ModalEcomm } from "@ncs/web-legos/components"
import { PublishedAsset } from "@ncs/ncs-api/portal-apps/point-of-sale/types"
import AssetRenderer from "./AssetRenderer"
import ThumbnailList from "./ThumbnailList"
import { useTheme } from "@emotion/react"
import {
	modalGalleryAssetStyle,
	modalGalleryAssetWrapperStyle,
	modalGalleryContainerStyle,
	modalGalleryContentStyle,
	modalGalleryHeaderStyle,
	thumbnailGalleryContainerStyle,
} from "./styles"

type ModalGalleryProps = {
	assets: PublishedAsset[]
	initialAssetToShow: string
	onClose: () => void
	isOpen: boolean
	partName: string
}

const ModalGallery: React.FC<ModalGalleryProps> = ({
	assets,
	initialAssetToShow,
	onClose,
	isOpen = false,
	partName = "",
}) => {
	const [currentAssetId, setCurrentAssetId] = useState<string>(initialAssetToShow)
	const theme = useTheme()
	const currentAsset =
		assets.find((asset) => asset.id.toString() === currentAssetId) ?? assets[0]

	const handleAssetClick = (id: string) => {
		setCurrentAssetId(id)
	}

	useEffect(() => {
		setCurrentAssetId(initialAssetToShow)
	}, [initialAssetToShow])

	return (
		<ModalEcomm maxWidth={"lg"} isOpen={isOpen} showCloseButton={false} onClose={onClose}>
			<div css={modalGalleryContainerStyle}>
				<header>
					<h2 css={modalGalleryHeaderStyle}>{partName}</h2>
				</header>
				<section css={modalGalleryContentStyle(theme)}>
					<article css={modalGalleryAssetWrapperStyle}>
						<AssetRenderer
							asset={currentAsset}
							isLoading={false}
							partImageStyle={modalGalleryAssetStyle}
							spinerStyle={modalGalleryAssetStyle}
							spinerMaxWidth={480}
						/>
					</article>
					<nav css={thumbnailGalleryContainerStyle}>
						<ThumbnailList
							assets={assets}
							selectedAsset={currentAssetId}
							onThumbnailClick={handleAssetClick}
							mode="full"
						/>
					</nav>
				</section>
			</div>
		</ModalEcomm>
	)
}

export default ModalGallery
